import phone from '../assets/img/phone.svg';
import mail from '../assets/img/mail.svg';
import planet from '../assets/img/Frame.svg';

import facebook from '../assets/img/facebook.svg';
import linkedin from '../assets/img/linkedin.svg';

const contacts = [
    {
        img: phone,
        text: '+38 095 279 42 12',
        href: 'tel:+38 095 279 42 12',
    },
    {
        img: mail,
        text: 'office@os-system.com',
        href: 'mailto:office@os-system.com',
    },
    {
        img: planet,
        text: 'os-system.com',
        href: 'https://os-system.com/',
    },
];

const socials = [
    linkedin,
    facebook,
]

export {
    socials,
    contacts,
};
